<template>
    <router-view appear :key="path"></router-view>
</template>


<script>
export default {
  name: "PricesModule",
  components: {},
  data: () => ({
    path: null
  }),
};
</script>
